import { render } from "./CarHeader.vue?vue&type=template&id=efd6dd18&scoped=true&ts=true"
import script from "./CarHeader.vue?vue&type=script&lang=ts"
export * from "./CarHeader.vue?vue&type=script&lang=ts"

import "./CarHeader.vue?vue&type=style&index=0&id=efd6dd18&scoped=true&lang=css"

import exportComponent from "/usr/home/demon/projects/driven/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd6dd18"]])

export default __exports__